import React from 'react';
import { Icon } from '@iconify/react';

const DEFAULT_ICON = 'noto:speech-balloon';

interface IconComponentProps {
  icon?: string;
  size?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

export default function IconComponent({ 
  icon, 
  size = 24, 
  color, 
  className, 
  style = {} 
}: IconComponentProps) {
  return (
    <Icon
      icon={icon || DEFAULT_ICON}
      width={size}
      height={size}
      color={color}
      className={className}
      style={style}
    />
  );
}
